import React from 'react';
import { Chef, Recipe } from './types';

interface ChefDetailProps {
  chef: Chef;
  recipes: Recipe[];
  onBack: () => void;
}

export const ChefDetail: React.FC<ChefDetailProps> = ({ chef, recipes, onBack }) => (
  <div className="chef-detail">
    <button className="back-button" onClick={onBack}>Back to List</button>
    <img src={chef.image_url} alt={chef.name} />
    <h2>{chef.name}</h2>
    <h3>{chef.establishment_name}</h3>
    <p>Cuisine: {chef.cuisine}</p>
    <p>Establishment Type: {chef.establishment_type}</p>
    <p>Location: {chef.location.city}, {chef.location.state}, {chef.location.country} {chef.location.zipcode}</p>
    <h4>Recipes</h4>
    <ul className="recipe-list">
      {recipes.map(recipe => (
        <li key={recipe.recipe_id} className="recipe-item">
          <h5>{recipe.name}</h5>
          <p>{recipe.description}</p>
          <p>Meal Type: {recipe.meal_type}</p>
          <p>Diet Type: {recipe.diet_type}</p>
          <p>Cooking Time: {recipe.cooking_time}</p>
        </li>
      ))}
    </ul>
  </div>
);